import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { HUB_TYPE_ENUM } from '../../../../../utils/constants';

export default function HubHeader({
    hub,
    hubs,
    workTabHubNShiftList,
    setWorkTabHubNShiftList,
    setShiftsWithHub,
    setAllowHubZoneEdit,
    index,
}) {
    console.log('HubHeader hub', index, hub);
    const hubInfo = hub?.hubInfo;
    const custInfo = hub?.custInfo;

    const handleDelete = () => {
        if (hub?.primaryOperation === HUB_TYPE_ENUM.FOOD.value) {
            setAllowHubZoneEdit(false);
        }
        const deletedHubId = [];
        setWorkTabHubNShiftList((prev) => {
            return prev?.filter((currentHub, inx) => {
                const isDeleted = inx !== index;
                if (!isDeleted) {
                    deletedHubId.push(currentHub?.hubId);
                }
                return isDeleted;
            });
        });
        setShiftsWithHub((prevState) => {
            const newState = { ...prevState };
            deletedHubId.forEach((hubId) => {
                delete newState[hubId];
            });
            return newState;
        });
    };

    const currentPrimaryOperation =
        hubs?.find((i) => hub?.hubId === i?.id)?.primaryOperation ??
        hub?.primaryOperation;

    console.log('HubHeader currentPrimaryOperation', index, hub);

    if (!hubInfo && !custInfo && !hub?.primaryOperation) {
        return <></>;
    }

    return (
        <>
            {!!hub?.primaryOperation && (
                <Box
                    style={{
                        backgroundColor:
                            HUB_TYPE_ENUM[
                                currentPrimaryOperation?.toUpperCase()
                            ]?.bgColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '6px 12px',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        border: 'solid 1px #f0e7e6',
                        borderBottom: 'none',
                    }}
                >
                    <Typography
                        variant="inherit"
                        style={{
                            color: '#252525',
                            fontSize: 14,
                        }}
                    >
                        Business type:{' '}
                        <Typography
                            variant="inherit"
                            style={{
                                color: '#252525',
                                fontWeight: 600,
                                fontSize: 14,
                            }}
                        >
                            {hub?.primaryOperation ?? '-'}
                        </Typography>
                    </Typography>
                    {workTabHubNShiftList?.length > 1 && (
                        <IconButton size="small" onClick={handleDelete}>
                            <DeleteIcon color="error" fontSize="small" />
                        </IconButton>
                    )}
                </Box>
            )}
            {hub?.primaryOperation !== HUB_TYPE_ENUM.ECOM.value &&
                !!custInfo && (
                    <Box
                        style={{
                            backgroundColor:
                                HUB_TYPE_ENUM[
                                    currentPrimaryOperation?.toUpperCase()
                                ]?.bgColor,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '6px 12px',
                        }}
                    >
                        <Typography
                            variant="inherit"
                            style={{
                                color: '#252525',
                                fontSize: 14,
                            }}
                        >
                            Business Name:{' '}
                            <Typography
                                variant="inherit"
                                style={{
                                    color: '#252525',
                                    fontWeight: 600,
                                    fontSize: 14,
                                }}
                            >
                                {custInfo?.aliasName ?? '-'}
                            </Typography>
                        </Typography>
                    </Box>
                )}
            {!!hubInfo && (
                <Box
                    style={{
                        backgroundColor:
                            HUB_TYPE_ENUM[
                                currentPrimaryOperation?.toUpperCase()
                            ]?.bgColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '6px 12px',
                    }}
                >
                    <Typography
                        variant="inherit"
                        style={{
                            color: '#252525',
                            fontSize: 14,
                        }}
                    >
                        Hub Name:{' '}
                        <Typography
                            variant="inherit"
                            style={{
                                color: '#252525',
                                fontWeight: 600,
                                fontSize: 14,
                            }}
                        >
                            {hubInfo?.name || hubInfo?.hubName}
                        </Typography>
                    </Typography>
                </Box>
            )}
        </>
    );
}
